import type { CalendarEvent } from "../../types/agenda"
import { EVENT_COLORS, EVENT_TYPE_CONFIG } from "../../constants/agenda"

interface Props {
  events: CalendarEvent[]
  onEventClick?: (event: CalendarEvent) => void
  showDate?: boolean
}

export function CalendarAllDayEvents({ events, onEventClick, showDate = false }: Props) {
  const items = events.filter(event => !event.start_time)
  if (!items.length) return null

  return (
    <section aria-label="Eventi senza orario" className="border-b border-[var(--hexa-border)] p-3">
      <h3 className="mb-2 text-xs font-medium text-[var(--hexa-text-secondary)]">Senza orario</h3>
      <div className="flex flex-wrap gap-2">
        {items.map(event => (
          <button key={event.id} type="button" data-event-id={event.id}
            onClick={() => onEventClick?.(event)}
            className="min-w-0 max-w-full min-h-10 rounded-lg border-l-4 bg-[var(--hexa-surface-elevated)] px-3 py-2 text-left text-xs text-[var(--hexa-text-primary)] break-words"
            style={{ borderColor: event.is_overdue ? '#ef4444' : EVENT_COLORS[event.type] || EVENT_COLORS.default }}>
            <span className="mr-2 text-[var(--hexa-text-muted)]">
              {showDate && `${new Date(`${event.start_date}T00:00:00`).toLocaleDateString('it-IT', { day: 'numeric', month: 'short' })} · `}
              {EVENT_TYPE_CONFIG[event.type]?.label || 'Evento'}
            </span>
            {" "}<span>{event.title}</span>
          </button>
        ))}
      </div>
    </section>
  )
}
